import { Component, EventEmitter, Input, Output } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { ShippingType } from '../../../../globalTypes/fulfillment.types';
import { ListingPublic } from '../../../../globalTypes/listings.types';
import { LimiterDirective } from '../../directive/limiter';
 '../'

@Component({
  selector: 'msh-parcel-dimensions',
  imports: [FormsModule, LimiterDirective],
  template: `

  <div class="flex items-center flex-wrap gap-8 justify-center" >
    <div class="flex items-center gap-2">
      <div class="mb-3">Length (longest):</div><input class=" !w-20 text-right" limiter [maxValue]="1000" type="number"[disabled]="readonly" [(ngModel)]="parcel.length"  min="0" (change)="parcelUpdated.emit()" /><div class=" opacity-50">{{parcel.distanceUnit}}</div>
    </div>
    <div class="flex items-center gap-2">
      <div class="mb-3">Width:</div><input class=" !w-20 text-right" limiter [maxValue]="1000" [disabled]="readonly" [(ngModel)]="parcel.width" type="number" min="0" (change)="parcelUpdated.emit()" /><div class=" opacity-50">{{parcel.distanceUnit}}</div>
    </div>
  </div>
  <div class="flex items-center flex-wrap gap-8 justify-center" >
    <div class="flex items-center gap-2">
        <div class="mb-3">
          @if(parcel.shippingCompressionRate && parcel.shippingCompressionRate > 0){
            Folded Thickness:
          } @else {
            Height (shortest):
          }
        </div><input class=" !w-20 text-right" limiter [maxValue]="1000" [disabled]="readonly" [(ngModel)]="parcel.height"  min="0" type="number" (change)="parcelUpdated.emit()" /><div class=" opacity-50">{{parcel.distanceUnit}}</div>
    </div>
    <div class="flex items-center gap-2">
      <div class="mb-3">Weight:</div><input class=" !w-20 text-right" limiter [maxValue]="1000" [disabled]="readonly" [(ngModel)]="parcel.weight" min="0" type="number" (change)="parcelUpdated.emit()" /><div class=" opacity-50">{{parcel.weightUnit}}</div>
    </div>
  </div>
  <div class="mt-3">
    <div class="mb-3 text-center w-full opacity-75">Compression Rate (optional):</div>
    <div class="flex justify-center flex-wrap mb-8 items-center gap-2">
      <div  class=" mb-3 opacity-50">Compresses by</div> <input limiter [maxValue]="1" class=" !w-20 text-right" step="0.1" min="0" max="0.99"[disabled]="readonly" (change)="parcelUpdated.emit()" [(ngModel)]="parcel.shippingCompressionRate" type="number" (change)="parcelUpdated.emit()" /><div class=" mb-3 opacity-50"> while packing</div>
    </div>
  </div>
  
  `,
  styles: ``
})
export class ParcelDimensionsComponent {
  @Input() shipmentType?: ShippingType
  @Input() readonly = false;
  @Input() parcel: ListingPublic | Partial<ListingPublic> = {
    weight: 0,
    height: 0,
    shippingCompressionRate: 0,
    distanceUnit: 'ft',
    length: 0,
    weightUnit: 'lb',
    width : 0,
  }
  @Output() parcelChange: EventEmitter<any> = new EventEmitter();
  @Output() parcelUpdated: EventEmitter<any> = new EventEmitter();
}
